export default [
  'blue',
  'red',
  'pink',
  'purple',
  'deep-purple',
  'indigo',
  'light-blue',
  'cyan',
  'teal',
  'green',
  'light-green',
  'lime',
  'amber',
  'orange',
  'deep-orange',
  'brown',
  'blue-grey'
]
